module.exports = __webpack_public_path__ + "static/media/SHARP_Logo_red.925b3a31.png";